<div class="category-nav-container">
  <div class="navbar navbar-default d-none d-xl-block" *ngIf="shimanoCategoryNavNode">
    <ul class="nav" (clickOutside)="resetDropdown()">
      <ng-container *ngFor="let categoryNav of shimanoCategoryNavNode.children; let i = index">
        <li
          *ngIf="categoryNav.entries.length > 0"
          class="dropdown"
          [class.show]="isInsideNavbar && isDropdownActive && showDropdown && activeI === i"
          (mouseup)="setShowDropdown($event, i)"
          (mouseenter)="setShowDropdown($event, i)"
        >
          <a
            [attr.aria-expanded]="isInsideNavbar && isDropdownActive && showDropdown && activeI === i"
            *ngIf="categoryNav.children?.length; else submenuNoChildren"
            >{{ categoryNav.entries[0]?.linkName }}</a
          >
          <ng-template #submenuNoChildren>
            <ng-container *ngIf="categoryNav.entries.length > 0">
              <ng-container *ngIf="isExternalUrl(categoryNav.entries[0]); else isLocalUrlForCategoryNav">
                <a
                  [href]="categoryNav.entries[0].url"
                  [attr.target]="categoryNav.entries[0].target ? '_blank' : undefined"
                  >{{ categoryNav.entries[0]?.linkName }}</a
                >
              </ng-container>
              <ng-template #isLocalUrlForCategoryNav>
                <a
                  *ngIf="!isGroupsetConfiguratorLink(categoryNav.entries[0].url); else groupsetConfiguratorLinkTempl"
                  [routerLink]="getLink(categoryNav.entries[0])"
                  [attr.target]="categoryNav.entries[0].target ? '_blank' : undefined"
                  >{{ categoryNav.entries[0]?.linkName }}</a
                >
                <ng-template #groupsetConfiguratorLinkTempl>
                  <a
                    [routerLink]="getGroupsetRouterLink(categoryNav.entries[0].url)"
                    [queryParams]="getGroupsetQueryParams(categoryNav.entries[0].url)"
                    [attr.target]="categoryNav.entries[0].target ? '_blank' : undefined"
                    >{{ categoryNav.entries[0]?.linkName }}</a
                  >
                </ng-template>
              </ng-template>
            </ng-container>
          </ng-template>
          <ul
            class="dropdown-menu rounded-0 border border-white"
            role="menu"
            *ngIf="categoryNav.children?.length > 0"
            [class.show]="isInsideNavbar && isDropdownActive && showDropdown && activeI === i"
          >
            <ng-container *ngFor="let groupGrandParentNavNode of categoryNav.children">
              <li class="groupGrandParentNavNode" [class.d-none]="!subMenuCheck.children.length">
                <ul [class]="'level-two ' + groupGrandParentNavNode.title" #subMenuCheck>
                  <ng-container *ngFor="let groupParentNavNode of groupGrandParentNavNode.children">
                    <li *ngIf="groupParentNavNode.entries.length > 0">
                      <ng-container
                        *ngIf="isExternalUrl(groupParentNavNode.entries[0]); else isLocalUrlForGroupParentNavNode"
                      >
                        <a
                          [href]="groupParentNavNode.entries[0].url"
                          [attr.target]="groupParentNavNode.entries[0].target ? '_blank' : undefined"
                          >{{ groupParentNavNode.entries[0]?.linkName }}</a
                        >
                      </ng-container>
                      <ng-template #isLocalUrlForGroupParentNavNode>
                        <a
                          [routerLink]="getLink(groupParentNavNode.entries[0])"
                          [attr.target]="groupParentNavNode.entries[0].target ? '_blank' : undefined"
                          >{{ groupParentNavNode.entries[0]?.linkName }}</a
                        >
                      </ng-template>
                      <ul class="level-three">
                        <li *ngFor="let groupChildNavNode of groupParentNavNode.children">
                          <ng-container *ngIf="groupChildNavNode.entries.length > 0">
                            <ng-container
                              *ngIf="isExternalUrl(groupChildNavNode.entries[0]); else isLocalUrlForGroupChildNavNode"
                            >
                              <a
                                [href]="groupChildNavNode.entries[0].url"
                                [attr.target]="groupChildNavNode.entries[0].target ? '_blank' : undefined"
                                >{{ groupChildNavNode.entries[0]?.linkName }}</a
                              >
                            </ng-container>
                            <ng-template #isLocalUrlForGroupChildNavNode>
                              <a
                                [routerLink]="getLink(groupChildNavNode.entries[0])"
                                [attr.target]="groupChildNavNode.entries[0].target ? '_blank' : undefined"
                                >{{ groupChildNavNode.entries[0]?.linkName }}</a
                              >
                            </ng-template>
                          </ng-container>
                          <ul class="level-four" *ngIf="groupChildNavNode.children.length > 0">
                            <li *ngFor="let levelFourNavNode of groupChildNavNode.children">
                              <ng-container *ngIf="levelFourNavNode.entries.length > 0">
                                <ng-container
                                  *ngIf="isExternalUrl(levelFourNavNode.entries[0]); else isLocalUrlForlevelFourNavNode"
                                >
                                  <a
                                    [href]="levelFourNavNode.entries[0].url"
                                    [attr.target]="levelFourNavNode.entries[0].target ? '_blank' : undefined"
                                    >{{ levelFourNavNode.entries[0]?.linkName }}</a
                                  >
                                </ng-container>
                                <ng-template #isLocalUrlForlevelFourNavNode>
                                  <a
                                    [routerLink]="getLink(levelFourNavNode.entries[0])"
                                    [attr.target]="levelFourNavNode.entries[0].target ? '_blank' : undefined"
                                    >{{ levelFourNavNode.entries[0]?.linkName }}</a
                                  >
                                </ng-template>
                              </ng-container>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ng-container>
                </ul>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>

  <div class="navbar d-xl-none" *ngIf="shimanoCategoryNavNode">
    <ul class="nav">
      <li
        class="dropdown catalogue"
        data-toggle="dropdown"
        [class.show]="showCatalogueDropdown"
        (click)="onClickCatalogueDropdown()"
        (clickOutside)="closeCatalogueDropdown()"
      >
        <span [attr.aria-expanded]="showCatalogueDropdown">
          {{ 'mobileNav.header' | cxTranslate
          }}<mat-icon class="material-icons-sharp md-12 ml-1 menu-button" [class.rotated]="showCatalogueDropdown"
            >expand_more</mat-icon
          >
        </span>
        <mat-nav-list
          class="dropdown-menu rounded-0 border border-white"
          [style.max-height.px]="getCategoryNavHeight()"
        >
          <ng-container *ngFor="let categoryNav of shimanoCategoryNavNode.children; let i = index">
            <div *ngIf="categoryNav.entries.length">
              <mat-list-item
                (click)="onClickSubMenu($event, i, categoryNav.entries[0].url); activeI = i"
                class="parent"
                disableRipple
              >
                <span
                  class="submenu"
                  [class.expanded]="showSubSubMenu && activeI === i"
                  *ngIf="categoryNav.children?.length; else submenuNoChildren"
                  >{{ categoryNav.entries[0]?.linkName }}</span
                >
                <ng-template #submenuNoChildren>
                  <ng-container *ngIf="categoryNav.entries.length > 0">
                    <ng-container *ngIf="isExternalUrl(categoryNav.entries[0]); else isLocalUrlForCategoryNav">
                      <a
                        class="submenu"
                        [href]="categoryNav.entries[0].url"
                        [attr.target]="categoryNav.entries[0].target ? '_blank' : undefined"
                        >{{ categoryNav.entries[0]?.linkName }}</a
                      >
                    </ng-container>
                    <ng-template #isLocalUrlForCategoryNav>
                      <a
                        *ngIf="
                          !isGroupsetConfiguratorLink(categoryNav.entries[0].url);
                          else groupsetConfiguratorLinkTempl
                        "
                        class="submenu"
                        [routerLink]="getLink(categoryNav.entries[0])"
                        [attr.target]="categoryNav.entries[0].target ? '_blank' : undefined"
                        >{{ categoryNav.entries[0]?.linkName }}</a
                      >
                      <ng-template #groupsetConfiguratorLinkTempl>
                        <a
                          class="submenu"
                          [routerLink]="getGroupsetRouterLink(categoryNav.entries[0].url)"
                          [queryParams]="getGroupsetQueryParams(categoryNav.entries[0].url)"
                          [attr.target]="categoryNav.entries[0].target ? '_blank' : undefined"
                          >{{ categoryNav.entries[0]?.linkName }}</a
                        >
                      </ng-template>
                    </ng-template>
                  </ng-container>
                </ng-template>

                <mat-icon
                  class="material-icons-sharp light md-16 ml-1 menu-button"
                  [class.rotated]="showSubSubMenu && activeI === i"
                  *ngIf="iSChildNotEmpty(categoryNav?.children, true)"
                  >expand_more</mat-icon
                >
              </mat-list-item>
              <div
                class="submenu-container"
                [class.expanded]="showSubSubMenu && activeI === i"
                [class.d-none]="!showSubSubMenu && activeI === i"
                *ngIf="showSubSubMenu && activeI === i"
              >
                <div
                  class="subsubmenu-container d-xl-none"
                  *ngFor="let groupGrandParentNavNode of categoryNav.children; let ii = index"
                >
                  <ng-container *ngFor="let groupParentNavNode of groupGrandParentNavNode.children; let iii = index">
                    <ng-container *ngIf="groupParentNavNode.entries.length > 0">
                      <div>
                        <mat-list-item
                          class="parent"
                          disableRipple
                          (click)="onClickSubSubMenu($event, i, ii, iii); activeI = i; activeIi = ii; activeIii = iii"
                        >
                          <span
                            class="subsubmenu"
                            [class.expanded]="
                              showSubSubSubMenu && activeI === i && activeIi === ii && activeIii === iii
                            "
                            *ngIf="groupParentNavNode.children?.length; else subsubMenuNoChildren"
                          >
                            <ng-container
                              *ngIf="
                                isExternalUrl(groupParentNavNode.entries[0]);
                                else isLocalUrlForGroupParentNavNodeLvl2
                              "
                            >
                              <a
                                class="subsubmenu"
                                (click)="
                                  closeCatalogueDropdown();
                                  goToLink(
                                    $event,
                                    groupParentNavNode.entries[0].url,
                                    groupParentNavNode.entries[0].target
                                  )
                                "
                                [href]="groupParentNavNode.entries[0].url"
                                [attr.target]="groupParentNavNode.entries[0].target ? '_blank' : undefined"
                                >{{ groupParentNavNode.entries[0]?.linkName | titlecase }}</a
                              >
                            </ng-container>
                            <ng-template #isLocalUrlForGroupParentNavNodeLvl2>
                              <a
                                class="subsubmenu"
                                (click)="
                                  closeCatalogueDropdown();
                                  goToLink(
                                    $event,
                                    groupParentNavNode.entries[0].url,
                                    groupParentNavNode.entries[0].target
                                  )
                                "
                                [routerLink]="getLink(groupParentNavNode.entries[0])"
                                [attr.target]="groupParentNavNode.entries[0].target ? '_blank' : undefined"
                                >{{ groupParentNavNode.entries[0]?.linkName | titlecase }}</a
                              >
                            </ng-template>
                          </span>
                          <ng-template #subsubMenuNoChildren>
                            <ng-container *ngIf="groupParentNavNode.entries.length > 0">
                              <ng-container
                                *ngIf="
                                  isExternalUrl(groupParentNavNode.entries[0]);
                                  else isLocalUrlForGroupParentNavNode
                                "
                              >
                                <a
                                  class="subsubmenu"
                                  (click)="
                                    closeCatalogueDropdown();
                                    goToLink(
                                      $event,
                                      groupParentNavNode.entries[0].url,
                                      groupParentNavNode.entries[0].target
                                    )
                                  "
                                  [href]="groupParentNavNode.entries[0].url"
                                  [attr.target]="groupParentNavNode.entries[0].target ? '_blank' : undefined"
                                  >{{ groupParentNavNode.entries[0]?.linkName }}</a
                                >
                              </ng-container>
                              <ng-template #isLocalUrlForGroupParentNavNode>
                                <a
                                  class="subsubmenu"
                                  (click)="
                                    closeCatalogueDropdown();
                                    goToLink(
                                      $event,
                                      groupParentNavNode.entries[0].url,
                                      groupParentNavNode.entries[0].target
                                    )
                                  "
                                  [routerLink]="getLink(groupParentNavNode.entries[0])"
                                  [attr.target]="groupParentNavNode.entries[0].target ? '_blank' : undefined"
                                  >{{ groupParentNavNode.entries[0]?.linkName }}</a
                                >
                              </ng-template>
                            </ng-container>
                          </ng-template>
                          <mat-icon
                            class="material-icons-sharp light md-16 ml-1 menu-button"
                            [class.rotated]="showSubSubSubMenu && activeI === i && activeIi === ii && activeIii === iii"
                            *ngIf="iSChildNotEmpty(groupParentNavNode?.children, false)"
                            >expand_more</mat-icon
                          >
                        </mat-list-item>
                        <div
                          class="level-three-menu-container d-xl-none"
                          [class.expanded]="showSubSubSubMenu && activeI === i && activeIi === ii && activeIii === iii"
                          *ngIf="showSubSubSubMenu && activeI === i && activeIi === ii && activeIii === iii"
                        >
                          <ng-template ngFor let-groupChildNavNode [ngForOf]="groupParentNavNode.children">
                            <ng-container *ngIf="groupChildNavNode.entries.length > 0">
                              <ng-container
                                *ngIf="isExternalUrl(groupChildNavNode.entries[0]); else isLocalUrlForGroupChildNavNode"
                              >
                                <mat-list-item
                                  disableRipple
                                  (click)="
                                    goToLink(
                                      $event,
                                      groupChildNavNode.entries[0].url,
                                      groupChildNavNode.entries[0].target
                                    )
                                  "
                                  ><a>{{ groupChildNavNode.entries[0]?.linkName }}</a></mat-list-item
                                >
                              </ng-container>
                              <ng-template #isLocalUrlForGroupChildNavNode>
                                <mat-list-item disableRipple [routerLink]="getLink(groupChildNavNode.entries[0])"
                                  ><a>{{ groupChildNavNode.entries[0]?.linkName }}</a></mat-list-item
                                >
                              </ng-template>
                              <div class="level-four-menu-container" *ngIf="groupChildNavNode.children.length > 0">
                                <ng-template ngFor let-levelFourNavNode [ngForOf]="groupChildNavNode.children">
                                  <ng-container *ngIf="levelFourNavNode.entries.length > 0">
                                    <ng-container
                                      *ngIf="
                                        isExternalUrl(levelFourNavNode.entries[0]);
                                        else isLocalUrlForlevelFourNavNode
                                      "
                                    >
                                      <mat-list-item
                                        disableRipple
                                        (click)="
                                          goToLink(
                                            $event,
                                            levelFourNavNode.entries[0].url,
                                            levelFourNavNode.entries[0].target
                                          )
                                        "
                                        ><a>{{ levelFourNavNode.entries[0]?.linkName }}</a></mat-list-item
                                      >
                                    </ng-container>
                                    <ng-template #isLocalUrlForlevelFourNavNode>
                                      <mat-list-item disableRipple [routerLink]="getLink(levelFourNavNode.entries[0])"
                                        ><a>{{ levelFourNavNode.entries[0]?.linkName }}</a></mat-list-item
                                      >
                                    </ng-template>
                                  </ng-container>
                                </ng-template>
                              </div>
                            </ng-container>
                          </ng-template>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
        </mat-nav-list>
      </li>
    </ul>
  </div>
</div>
